import type { Ratings as RatingsType } from "../../types";
import { Ratings as Control } from "./Ratings";

export type RatingsProps = {
  data: RatingsType;
};

export const Ratings = (props: RatingsProps) => {
  return <Control {...props} />;
};
